import { Moon, Sun } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/contexts/useTheme';

interface PublicHeaderProps {
  actionTo?: string;
  actionLabel?: string;
}

export function PublicHeader({
  actionTo = '/login',
  actionLabel = 'Sign in',
}: PublicHeaderProps) {
  const { theme, setTheme } = useTheme();

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-foreground focus:px-4 focus:py-3 focus:text-background"
      >
        Skip to content
      </a>
      <header className="border-b border-border">
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-4 px-5 sm:px-8 lg:px-12">
          <Link
            to="/welcome"
            aria-label="Richtato home"
            className="flex items-center gap-2.5 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4 focus-visible:ring-offset-background"
          >
            <img
              src="/richtato.png"
              alt=""
              className="h-10 w-10 shrink-0 rounded-xl"
            />
            <span className="text-xl font-semibold tracking-tight">
              Richtato
            </span>
          </Link>
          <div className="flex items-center gap-3 sm:gap-6">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
              className="text-muted-foreground hover:bg-muted hover:text-foreground"
              aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            >
              {theme === 'light' ? (
                <Moon aria-hidden="true" className="h-4 w-4" />
              ) : (
                <Sun aria-hidden="true" className="h-4 w-4" />
              )}
            </Button>
            <Link
              to={actionTo}
              className="rounded-sm text-sm font-medium transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4 focus-visible:ring-offset-background"
            >
              {actionLabel}
            </Link>
          </div>
        </div>
      </header>
    </>
  );
}
